<template>
  <div id="vuetify-crud-datatable">
    <v-dialog v-model="dialogConfirm" max-width="290">
      <v-card>
        <v-card-title class="headline">{{ text['delete_element'] }}</v-card-title>
        <v-card-text>{{ getConfirmationMessage() }} </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :color="secundaryButtonColor" flat="flat" @click.native="dialogConfirm = false">{{ text['cancel'] }}</v-btn>
          <v-btn :color="primaryButtonColor" flat="flat" @click="deleteItem(editedItemIndex)">{{ text['delete'] }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-btn
        v-if="addButton"
        :color="primaryButtonColor"
        :dark='true'
        class="mb-2"
        @click="onClickAddButton()"
      >
        {{ text['new'] }} {{ name }}
      </v-btn>
      <v-btn
        v-if="markButton && checkbox !== false && selected.length > 0"
        :dark="true"
        color="teal"
        class="mb-2" @click.native="markSelected"
      >
        {{ text['mark_selecteds'] }}
      </v-btn>
      <v-btn
        v-if="cloneButton && checkbox !== false && selected.length > 0"
        :dark="true"
        color="purple darken-1"
        class="mb-2" @click.native="cloneSelected"
      >
        {{ text['clone_selecteds'] }}
      </v-btn>
      <v-btn
        v-if="deleteButton && checkbox !== false && selected.length > 0"
        :dark="true"
        color="red"
        class="mb-2" @click.native="deleteSelected"
      >
        {{ text['delete_selecteds'] }}
      </v-btn>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card light>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout v-if='editedItemIndex !== -1' wrap>
              <v-flex
                v-for="(item, i) in editedItem" :key="i"
                xs12 sm12 md12 v-if='getItemVisibilityByValue(i) !== false'
              >
                <v-text-field
                  v-if='getItemTypeByValue(i) === "editable-text-field"'
                  :label="getItemLabelByValue(i)"
                  v-model="editedItem[i]"
                  :counter="getItemCounterByValue(i)"
                  :rules="[getItemRulesByValue(i)]"
                ></v-text-field>
                <v-select
                  v-if='getItemTypeByValue(i) === "select"'
                  :label="getItemLabelByValue(i)"
                  :item-text="getItemPropTextByValue(i) || 'text'"
                  :item-value="getItemPropValueByValue(i) || 'value'"
                  :items="getItemOptionsByValue(i)"
                  v-model="editedItem[i]"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout wrap v-else>
              <v-flex
                v-for="(item, i) in editedItem"
                v-if='getItemVisibilityByValue(i) !== false' :key="i"
                xs12 sm12 md12
              >
                <v-text-field
                  v-if='getItemTypeByValue(i) === "editable-text-field"'
                  :label="getItemLabelByValue(i)"
                  v-model="editedItem[i]"
                  :counter="getItemCounterByValue(i)"
                  :rules="[getItemRulesByValue(i)]"
                ></v-text-field>
                <v-select
                  v-if='getItemTypeByValue(i) === "select"'
                  :label="getItemLabelByValue(i)"
                  :item-text="getItemPropTextByValue(i) || 'text'"
                  :item-value="getItemPropValueByValue(i) || 'value'"
                  :items="getItemOptionsByValue(i)"
                  v-model="editedItem[i]"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :color="primaryColor" flat @click.native="close">
            {{ text['cancel'] }}
          </v-btn>
          <v-btn :color="primaryColor" flat @click.native="save">
            {{ text['save'] }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card-title>
      {{ pluralName | capitalize }}
      <v-spacer></v-spacer>
      <v-text-field
        append-icon="search"
        :label="text['search'] + ' ' + name"
        single-line
        hide-details
        v-model="search"
      ></v-text-field>
    </v-card-title>
    <v-container v-if="displayFilters" fluid grid-list-lg text-xs-center>
      <v-layout row wrap>
        <v-flex xs12 sm3>
          <v-menu
            ref="dateFromMenu"
            v-model="dateFromMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="dateFrom"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template>
              <v-text-field
                slot="activator"
                v-model="dateFromm"
                label="Desde"
                readonly
              ></v-text-field>
            </template>
            <v-date-picker locale="es-es" :first-day-of-week="1" color="indigo" v-model="dateFrom" @input="saveDate('start')" no-title scrollable>
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 sm3 d-flex>
          <v-menu
            ref="dateToMenu"
            v-model="dateToMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="dateTo"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template>
              <v-text-field
                slot="activator"
                v-model="dateToo"
                label="Hasta"
                readonly
              ></v-text-field>
            </template>
            <v-date-picker locale="es-es" :first-day-of-week="1" color="indigo" v-model="dateTo" @input="saveDate('end')" no-title scrollable>
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 sm3 d-flex>
          <v-select
            v-model="filterBy"
            :items="dateOptions"
            label="Filtrar por fecha"
            class="filter-select"
          ></v-select>
        </v-flex>
        <v-flex xs12 sm3 d-flex>
          <v-select
            v-model="status"
            :items="statuses"
            label="Estado"
            class="filter-select"
          ></v-select>
        </v-flex>
        <v-flex xs12 sm3 d-flex>
          <v-select
            v-model="selectedBusiness"
            :items="business"
            label="Grupo empresarial"
            class="filter-select"
          ></v-select>
        </v-flex>
        <v-flex xs12 sm3 d-flex>
          <v-select
            v-model="selectedCompany"
            :items="companies"
            label="Empresa"
            class="filter-select"
          ></v-select>
        </v-flex>
        <v-flex xs12 sm3 d-flex>
          <v-select
            v-model="selectedCommerce"
            :items="commerces"
            label="Comercio"
            class="filter-select"
          ></v-select>
        </v-flex>
        <v-flex xs12 sm3 d-flex>
          <v-select
            v-model="selectedInstaller"
            :items="installers"
            label="Instalador"
            class="filter-select"
          ></v-select>
        </v-flex>
      </v-layout>
    </v-container>
    <v-data-table
      :headers="theHeaders"
      :color="primaryColor"
      :items="items"
      :loading="false"
      :disable-initial-sort="true"
      :rows-per-page-items='rowsPerPage'
      :rows-per-page-text="text['rows_per_page_items'] + ':'"
      :no-results-text="text['no_results_text']"
      :no-data-text="text['no_data_text']"
      class="elevation-1"
      :search="search"
      v-model="selected"
      :item-key="itemKey"
      :select-all="checkbox"
      v-bind:pagination.sync="customPagination"
    >
    <template slot="headers" slot-scope="props">
      <draggable v-model="props.headers" :options="getOptions()" class="dragArea" element="tr" :move="onMove" @start="onStart" @end="onEnd">
        <th
          v-for="(header, index) in props.headers"
          :key="index"
          :style="'text-align: ' + (header.align ? header.align : 'center')"
          :class="header.type !== 'checkbox' && header.type !== 'actions' ? ['column sortable', customPagination.descending ? 'desc' : 'asc', header.value === customPagination.sortBy ? 'active' : ''] : 'no-drag'"
          @click="header.sortable ? changeSort(header.value) : false"
        >
          <v-checkbox
            v-if="header.type === 'checkbox'"
            :input-value="props.all"
            :indeterminate="props.indeterminate"
            primary
            hide-details
            @click.native="toggleAll"
          ></v-checkbox>
        <span v-else>
        {{ header.text }}
          <v-icon small v-if="header.sortable">arrow_upward</v-icon>
          </span>
        </th>
      </draggable>
      </template>
      <template slot="items" slot-scope="props">
        <td v-if="checkbox !== false"  :class="isDragging ? 'opacity-all' : ''">
          <v-checkbox
            :color="checkbox"
            hide-details
            v-model="props.selected"
            :input-value="props.all"
            :indeterminate="props.indeterminate"
          ></v-checkbox>
        </td>
        <td v-if="getItemTypeByValue(i) && i !== 'actions'" v-for="(item, i) in sortColumns(props.item)" :key="i" :class="isDragging ? 'opacity-all' : 'opacity-off'">
          <span v-if='getItemTypeByValue(i) === "span"'>
            {{ props.item[i] }}
          </span>
          <span v-if='getItemTypeByValue(i) === "select"'>
            {{ props.item[i] }}
          </span>
          <v-edit-dialog
            v-if='getItemTypeByValue(i) === "editable-text-field"'
            :return-value.sync="props.item[i]"
            lazy
          > {{ props.item[i] }}
            <v-text-field
              label="Edit"
              v-model="props.item[i]"
              slot="input"
              single-line
              :counter="getItemCounterByValue(i)"
              autofocus
              :rules="[getItemRulesByValue(i)]"
              @change="editInputText(getIndexByItemKey(props.item[itemKey]))"
            ></v-text-field>
          </v-edit-dialog>
        </td>

        <td v-if="actions" class="justify-center layout px-0" :class="isDragging ? 'opacity-all' : ''">
          <v-btn
            icon
            class="mx-0"
            @click="editItem(getIndexByItemKey(props.item[itemKey]), props.item[itemKey])"
          >
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn
            v-if="deleteButton"
            icon
            class="mx-0"
            @click.native.stop="confirmDeletion(getIndexByItemKey(props.item[itemKey]))">
            <v-icon color="red">delete</v-icon>
          </v-btn>
        </td>
      </template>

      <template slot="pageText" slot-scope="{ pageStart, pageStop }">
        {{ text['from'] }} {{ pageStart }} {{ text['to'] }} {{ pageStop }}
      </template>
      <v-alert
        slot="no-results"
        :value="true"
        color="error"
        icon="warning"
      >
        {{ text['no_results_found_for'] }} "{{ search }}".
      </v-alert>
    </v-data-table>
    <v-btn
      class="settings-btn"
      @click="sheet = true"
      v-show="isLoaded"
      absolute
      dark
      fixed
      fab
      bottom
      right
      color="primary"
    >
      <v-icon>settings</v-icon>
    </v-btn>
    <div class="text-xs-center">
      <v-bottom-sheet v-model="sheet">

        <v-card class="options-card">
                  <v-btn @click="sheet = !sheet" class="close" flat icon color="#757575" absolute right>
          <v-icon class="close-icon">close</v-icon>
        </v-btn>
          <v-subheader>{{ text['columns'] }} 
            <v-tooltip right>
              <v-icon
                class="info-icon"
                slot="activator"
                color="primary"
                small
                dark
              >help_outline</v-icon>
              <span>{{ text['columns_info'] }}</span>
            </v-tooltip>
          </v-subheader>
          <v-container fluid grid-list-xl class="checkboxes">
            <v-layout column justify-space-between>
            <ul>
                <li v-show="header.type !== 'actions' && header.type !== 'checkbox'" v-for="(header, index) in headers" :key="header.value" class="checkbox-column" @click="setColumnsVisibility(header.value)">
                <v-checkbox
                  v-model="customColumns"
                  :label="header.text"
                  color="primary"
                  :value="header.value"
                  hide-details
                ></v-checkbox>
              </li>
            </ul>
          </v-layout>
          </v-container>
            <v-subheader>{{ text['restart_columns'] }}
            <v-tooltip right>
              <v-icon
                class="info-icon"
                slot="activator"
                color="primary"
                small
                dark
              >error_outline</v-icon>
              <span>{{ text['columns_warning'] }}</span>
            </v-tooltip>
            </v-subheader>


          <v-btn class="reset-btn" small outline color="primary" dark @click="resetColumns()">
                {{ text['reset'] }}
              </v-btn>

            <v-subheader v-if="displayFilters">Reiniciar filtros</v-subheader>


          <v-btn v-if="displayFilters" class="reset-btn" small outline color="primary" dark @click="resetFilters()">
                {{ text['reset'] }}
              </v-btn>

        </v-card>
      </v-bottom-sheet>
    </div>
  </div>
</template>

<script>

'use strict'
import draggable from 'vuedraggable'
import moment from 'moment'

export default {

  name: 'VuetifyCrudDatatable',

  components: {
    draggable
  },

  props:
  {
    translations: {
      type: Object,
      default: null
    },
    name: {
      type: String,
      default: null,
      required: true
    },
    pluralName: {
      type: String,
      default: null,
      required: true
    },
    rowsPerPageItems: {
      type: Array,
      default: null
    },
    headers: {
      type: Array,
      default: null,
      required: true
    },
    rows: {
      type: Array,
      default: null,
      required: true
    },
    itemKey: {
      type: String,
      default: 'id'
    },
    checkboxColor: {
      type: String,
      default: 'primary'
    },
    primaryColor: {
      type: String,
      default: 'primary'
    },
    primaryButtonColor: {
      type: String,
      default: 'primary'
    },
    secundaryButtonColor: {
      type: String,
      default: 'secundary'
    },
    selectedColumns: {
      type: Array,
      default: null
    },
    business: {
      type: Array,
      default: () => [],
      required: false
    },
    companies: {
      type: Array,
      default: () => [],
      required: false
    },
    commerces: {
      type: Array,
      default: () => [],
      required: false
    },
    installers: {
      type: Array,
      default: () => [],
      required: false
    },
    pagination: {
      type: Object,
      default: null
    },
    defaultColumns: {
      type: Object,
      default: null,
      required: true
    },
    addDialog: {
      type: Boolean,
      default: true,
      required: false
    },
    editDialog: {
      type: Boolean,
      default: true,
      required: false
    },
    deleteButton: {
      type: Boolean,
      default: true,
      required: false
    },
    cloneButton: {
      type: Boolean,
      default: false,
      required: false
    },
    displayFilters: {
      type: Boolean,
      default: false,
      required: false
    },
    markButton: {
      type: Boolean,
      default: false,
      required: false
    },
    addButton: {
      type: Boolean,
      default: true,
      required: false
    },
    /**
     * Translations for button texts.
     * @default null
     * @type {Object}
     */
    translatiosns: {
      type: Object,
      default: null
    }
  },

  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },

  data: () => ({
    dateOptions: [
      {
        text: 'Inicio instalación',
        value: 'booking_installation_start_date'
      },
      {
        text: 'Fin instalación',
        value: 'booking_installation_end_date'
      },
      {
        text: 'Fecha de venta',
        value: 'sale_sold_date'
      }
    ],
    statuses: [
      {
        text: 'Pendiente',
        value: 6
      },
      {
        text: 'Cita programada',
        value: 13
      },
      {
        text: 'En transcurso',
        value: 7
      },
      {
        text: 'Anulada',
        value: 8
      },
      {
        text: 'Aplazada',
        value: 9
      },
      {
        text: 'No instalada por iBEC',
        value: 14
      },
      {
        text: 'Terminada sin incidencias',
        value: 10
      },
      {
        text: 'Terminada con incidencias',
        value: 11
      },
      {
        text: 'Pendiente',
        value: 6
      }
    ],
    dateFromMenu: null,
    dateToMenu: null,
    dateFrom: null,
    dateTo: null,
    filterBy: null,
    status: null,
    customColumns: null,
    b: null,
    sheet: false,
    arrayMove: require('array-move'),
    isDraggable: false,
    isLoaded: false,
    theHeaders: [],
    isDragging: false,
    delayedDragging: false,
    items: [],
    availableColumns: [],
    editedItemIndex: -1,
    editedHeaderIndex: -1,
    editedItem: [],
    selectedBusiness: null,
    selectedCompany: null,
    selectedCommerce: null,
    selectedInstaller: null,
    defaultItem: [],
    search: '',
    actions: false,
    checkbox: false,
    selected: [],
    dialog: false,
    dialogConfirm: false,
    text: {
      'new': 'New',
      'edit': 'Edit',
      'cancel': 'Cancel',
      'save': 'Save',
      'delete': 'Delete',
      'columns': 'Colums',
      'columns_info': 'To change the order of the columns, simply drag them from one place to another',
      'columns_warning': 'WARNING: This will remove your custom selection and reset the columns to the default selection',
      'restart_columns': 'Reset columns',
      'reset': 'Reset',
      'delete_selecteds': 'Deleted selected',
      'clone_selecteds': 'Clone selected',
      'mark_selecteds': 'Mark selected',
      'delete_element': 'Delete item',
      'delete_element_message': 'You\'re about to delete an ',
      'search': 'Search',
      'rows_per_page_items': 'Rows per page',
      'no_results_text': 'No data available',
      'no_data_text': 'No matches found',
      'from': 'From',
      'to': 'to',
      'no_results_found_for': 'No results found for'
    },
    rowsPerPage: [5, 10, 25, { 'text': 'All', 'value': -1 }],
    customPagination: {
      'sortBy': 'id',
      'ascending': true,
      'rowsPerPage': -1
    }
  }),

  computed: {
    formTitle () {
      return this.editedItemIndex === -1
        ? this.text['new'] + ' ' + this.name
        : this.text['edit'] + ' ' + this.name
    },
    dateToo () {
      return this.dateTo ? moment(this.dateTo).format('DD-MM-YYYY') : null
    },
    dateFromm () {
      return this.dateFrom ? moment(this.dateFrom).format('DD-MM-YYYY') : null
    }
  },

  watch: {
    filterBy (val) {
      this.onChangeFilters()
    },
    status (val) {
      this.onChangeFilters()
    },
    dateFrom (val) {
      this.onChangeFilters()
    },
    dateTo (val) {
      this.onChangeFilters()
    },
    selectedBusiness (val) {
      this.onChangeFilters()
    },
    selectedCompany (val) {
      this.onChangeFilters()
    },
    selectedCommerce (val) {
      this.onChangeFilters()
    },
    selectedInstaller (val) {
      this.onChangeFilters()
    },
    dialog (val) {
      val || this.close()
    },
    dialogConfirm (val) {
      val || this.close()
    },
    headers () {
      this.normalizeColumns()
    },
    rows () {
      this.items = this.rows
      this.initialize()
    },
    selectedColumns () {
      this.customColumns = this.selectedColumns
      this.normalizeColumns()
    },
    customColumns () {
      this.$emit('on-change-columns', this.customColumns)
    },
    isDragging (newValue) {
      if (newValue) {
        this.delayedDragging = true
        return
      }
      this.$nextTick(() => {
        this.delayedDragging = false
      })
    }
  },

  methods: {

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    normalizeColumns () {
      this.theHeaders = []
      this.theHeaders.push({
        text: 'checkbox',
        value: 'checkbox',
        type: 'checkbox',
        fixed: true
      })
      this.setAvailableColumns()
      let selectedColumns = (this.selectedColumns && this.selectedColumns.length) ? this.selectedColumns : this.availableColumns
      selectedColumns.forEach((value) => {
        let index = this.headers.findIndex(item => item.value === value)
        if (index !== -1) {
          this.theHeaders.push(this.headers[index])
        }
      })
    },

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    calculateIndex (value) {
      let index = this.availableColumns.indexOf(value)
      let iterator = index - 1
      while (iterator > -1) {
        let value = this.availableColumns[iterator]
        let i = this.customColumns.indexOf(value)
        if (i > -1) {
          return i + 1
        }
        iterator--
      }
      iterator = index + 1
      while (iterator < this.availableColumns.length) {
        let value = this.availableColumns[iterator]
        let i = this.customColumns.indexOf(value)
        if (i > -1) {
          return i - 1
        }
        iterator++
      }
      return -1
    },

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setColumnsVisibility (value) {
      let index = this.headers.findIndex(item => item.value === value)
      let customColumnIndex = this.customColumns.indexOf(value)
      if (customColumnIndex > -1) {
        this.customColumns.splice(customColumnIndex, 1)
        let newIndex = this.calculateIndex(value)
        this.customColumns.splice(newIndex, 0, value)
        return this.theHeaders.splice(newIndex, 0, this.headers[index])
      }
      index = this.theHeaders.findIndex(item => item.value === value)
      // console.log(index)
      this.theHeaders.splice(index, 1)
    },

    saveDate (type) {
      if (type === 'start') {
        this.$refs.dateFromMenu.save(this.dateFrom)
        this.dateFromMenu = false
      } else {
        this.$refs.dateToMenu.save(this.dateTo)
        this.dateToMenu = false
      }
    },

    setFilters (filters) {
      this.filterBy = filters.filterBy || null
      this.status = filters.status || null
      this.dateFrom = filters.dateFrom || null
      this.dateTo = filters.dateTo || null
      this.selectedBusiness = filters.business || null
      this.selectedCompany = filters.company || null
      this.selectedCommerce = filters.commerce || null
      this.selectedInstaller = filters.installer || null
    },

    onMove ({relatedContext, draggedContext}) {
      const relatedElement = relatedContext.element
      const draggedElement = draggedContext.element
      this.isDraggable = (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      return this.isDraggable
    },

    onChangeFilters () {
      this.$emit('on-change-filters', {
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        filterBy: this.filterBy,
        status: this.status,
        business: this.selectedBusiness,
        company: this.selectedCompany,
        commerce: this.selectedCommerce,
        installer: this.selectedInstaller
      })
    },

    onStart (event) {
      this.isDragging = true
      return false
    },

    onEnd (event) {
      this.isDragging = false
      this.theHeaders = this.arrayMove(this.theHeaders, event.oldIndex, event.newIndex)
      this.initialize()
    },

    setCustomColumns () {
      this.customColumns = []
      this.theHeaders.forEach((obj, index) => {
        this.customColumns.push(obj.value)
      })
    },

    setAvailableColumns () {
      this.availableColumns = []
      this.availableColumns.push('checkbox')
      this.headers.forEach((obj, index) => {
        this.availableColumns.push(obj.value)
      })
    },

    getOptions () {
      return {
        sort: true,
        animation: 500,
        group: {
          name: 'tags',
          pull: true,
          put: true
        },
        disabled: false,
        ghostClass: 'ghost'
      }
    },

    resetFilters () {
      this.setFilters({
        dateFrom: null,
        dateTo: null,
        filterBy: null,
        status: null,
        business: null,
        company: null,
        commerce: null,
        installer: null
      })
    },

    resetColumns () {
      this.customColumns = this.availableColumns
      this.theHeaders = []
      this.theHeaders.push({
        text: 'checkbox',
        value: 'checkbox',
        type: 'checkbox',
        fixed: true
      })
      this.headers.forEach((obj, index) => {
        this.theHeaders.push(obj)
      })
    },

    changeSort (column) {
      if (this.customPagination.sortBy === column) {
        this.customPagination.descending = !this.customPagination.descending
      } else {
        this.customPagination.sortBy = column
        this.customPagination.descending = false
      }
    },

    initialize () {
      this.setCustomColumns()
      this.text = this.translations || this.text
      this.items = this.rows || this.items

      this.customPagination = this.pagination || this.customPagination
      var defaultColumns = {}
      for (var key in this.defaultColumns) {
        defaultColumns[key] = this.defaultColumns[key]
      }

      var editedItem = {}
      for (key in this.defaultColumns) {
        editedItem[key] = this.defaultColumns[key]
      }

      this.defaultItem = defaultColumns
      this.editedItem = editedItem

      this.actions = this.theHeaders.findIndex(item => item.type === 'actions') > -1

      this.checkbox = typeof defaultColumns.value !== 'undefined' ? this.checkboxColor : false

      setTimeout(() => { this.isLoaded = true }, 1000)
    },

    sortColumns (elements) {
      // console.log('++++', elements)
      let items = {}
      this.theHeaders.forEach((item, index) => {
        if (item.value !== 'checkbox') {
          items[item.value] = elements[item.value]
        }
      })
      // console.log('++++', items)
      elements = items
      return elements
    },

    getIndexByValue (value) {
      return this.theHeaders.findIndex(item => item.value === value)
    },

    getIndexByItemKey (itemKey) {
      return this.items.findIndex(item => item[this.itemKey] === itemKey)
    },

    getItemLabelByValue (value) {
      const index = this.getIndexByValue(value)
      if (index !== false && this.theHeaders[index]) {
        return this.theHeaders[index].text
      }
      return ''
    },

    getItemOptionsByValue (value) {
      const index = this.getIndexByValue(value)
      if (index !== false && this.theHeaders[index]) {
        return this.theHeaders[index].options
      }
      return ''
    },

    getItemPropTextByValue (value) {
      const index = this.getIndexByValue(value)
      if (index !== false && this.theHeaders[index]) {
        return this.theHeaders[index].property_text
      }
      return ''
    },

    getItemPropValueByValue (value) {
      const index = this.getIndexByValue(value)
      if (index !== false && this.theHeaders[index]) {
        return this.theHeaders[index].property_value
      }
      return ''
    },

    getItemTypeByValue (value) {
      const index = this.getIndexByValue(value)
      if (index !== false && this.theHeaders[index]) {
        return this.theHeaders[index].type
      }
      return ''
    },

    getItemRulesByValue (value) {
      const index = this.getIndexByValue(value)
      if (index !== false && this.theHeaders[index]) {
        return this.theHeaders[index].rules
      }
      return ''
    },

    getItemCounterByValue (value) {
      const index = this.getIndexByValue(value)
      if (index !== false && this.theHeaders[index]) {
        return this.theHeaders[index].counter
      }
      return ''
    },

    getMainItemByIndex (index) {
      return this.theHeaders.findIndex(item => typeof item.main !== 'undefined')
    },

    getItemVisibilityByValue (value) {
      const index = this.getIndexByValue(value)
      if (index !== false && this.theHeaders[index]) {
        return this.theHeaders[index].editable || false
      }
      return false
    },

    getConfirmationMessage () {
      let index = this.editedHeaderIndex
      let headerText = this.theHeaders[index] ? this.theHeaders[index].text.toLowerCase() : ''
      let headerValue = this.theHeaders[index] ? this.theHeaders[index].value : ''

      return this.text['delete_element_message'] + ' ' + headerText + ' ' + this.editedItem[headerValue] + '.'
    },

    editItem (index, value) {
      if (this.editDialog) {
        this.editedItemIndex = index
        this.editedItem = Object.assign({}, this.items[index])
        this.dialog = true
      }
      this.$emit('on-click-edit-button', index, value)
    },

    editInputText (index) {
      this.$emit('on-edit', index)
    },

    confirmDeletion (index) {
      this.editedHeaderIndex = this.getMainItemByIndex(index)
      this.editedItemIndex = index
      this.editedItem = Object.assign({}, this.items[index])
      this.dialogConfirm = true
    },

    markItem (item) {
      this.$emit('on-mark', item)
    },

    cloneItem (index) {
      this.$emit('on-clone', index)
    },

    deleteItem (index) {
      this.$emit('on-delete', index)
      this.items.splice(index, 1)
      this.close()
    },

    close () {
      this.dialog = false
      this.dialogConfirm = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedItemIndex = -1
        this.editedHeaderIndex = -1
      }, 500)
    },

    onClickAddButton () {
      if (this.addDialog) {
        this.dialog = true
      }
      this.$emit('on-click-add-button')
    },

    toggleAll () {
      if (this.selected.length) this.selected = []
      else this.selected = this.items.slice()
    },

    selectAll () {
      this.selected = this.items.slice()
    },

    save () {
      if (this.editedItemIndex > -1) {
        Object.assign(this.items[this.editedItemIndex], this.editedItem)
        this.$emit('on-edit', this.editedItemIndex)
      } else {
        let index = 0
        if (this.items.length > 0) {
          index = this.items[this.items.length - 1][this.itemKey]
        }
        this.editedItem[this.itemKey] = index + 1
        let item = {}
        for (var i in this.editedItem) {
          if (this.editedItem[i] !== false) {
            item[i] = {}
            item[i] = this.editedItem[i]
          }
        }
        this.items.push(item)
        this.$emit('on-add', this.items.length - 1)
      }
      this.close()
    },

    markSelected () {
      for (var i in this.selected) {
        this.markItem(this.selected[i])
      }
      this.selected = []
    },

    cloneSelected () {
      for (var i in this.selected) {
        let index = this.items.indexOf(this.selected[i])
        this.cloneItem(index)
      }
      this.selected = []
    },

    deleteSelected () {
      for (var i in this.selected) {
        let index = this.items.indexOf(this.selected[i])
        this.deleteItem(index)
      }
      this.selected = []
    }
  }
}
</script>

<style lang="sass">
.card
  background-color: #ffffff !important
  border-color: #ffffff !important

.ghost
  opacity: 0.4
  border: 1px dotted #e0e0e0

.opacity-all
  opacity: 0
  pointer-events: none
  cursor: default
  text-decoration: none
  -webkit-transition: opacity 0.4s ease-out
  -moz-transition: opacity 0.4s ease-out
  -ms-transition: opacity 0.4s ease-out
  -o-transition: opacity 0.4s ease-out
  transition: opacity 0.4s ease-out

.opacity-off
  opacity: 1
  -webkit-transition: opacity 0.4s ease-in
  -moz-transition: opacity 0.4s ease-in
  -ms-transition: opacity 0.4s ease-in
  -o-transition: opacity 0.4s ease-in
  transition: opacity 0.4s ease-in

.settings-btn
  margin-bottom: 48px

.checkbox-column 
  -webkit-box-align: center
  -ms-flex-align: center
  align-items: center
  display: -webkit-inline-box
  display: -ms-inline-flexbox
  display: inline-flex
  -webkit-box-flex: 0
  -ms-flex: 0 1 auto
  justify-content: center
  min-width: 180px

.flip-list-move
  transition: transform 0.3s

.flip-list-item
  display: inline-block
  margin-right: 10px

.flip-list-enter-active, .flip-list-leave-active
  transition: all 0.3s

.flip-list-enter, .flip-list-leave-to
  opacity: 0
  transform: translateY(-50px)

.no-drag
 -webkit-user-drag: none
  -khtml-user-drag: none
  -moz-user-drag: none
  -o-user-drag: none
  user-drag: none

.no-move
  transition: transform 0s

.checkbox-column > div > label
  font-size: 12px

.info-icon
  cursor: pointer
  margin-left: 3px

.options-card
  padding: 30px 0px 30px 40px

.checkboxes,
  margin-left: 5px

.reset-btn
  margin-left: 19px

.close
  z-index: 9999999999 !important
  top: 0
  margin: 22px 7px 0 0

.close-icon
  font-size: 35px
  color: #757575 !important

#vuetify-crud-datatable
  margin-bottom: 50px

.item-row
  cursor: pointer

.item-row:hover
  background: rgba(0, 0, 0, 0.1) !important

.filter-select > div
  max-height: 30px !important
</style>


// WEBPACK FOOTER //
// src/components/vuetify-crud-datatable.vue